import { useEffect } from "react";
import { paramsListName } from "src/api/config";
import { myTasksIncidentsStatusesListName } from "src/api/config/myTasksInc.config";
import { incStatus } from "src/api/config/systemSwitch";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems } from "src/modules/spItems/selectors";

export const Statuses5WayNotice = ({ typeInc, statuses }: any) => {

    const params: any = useAppSelector((state) => selectItems(state, paramsListName));

    return (
        <div className='flex flex-col w-full gap-[10px] p-[10px]'>
            {typeInc && statuses.map((status: any) => (
                <>
                    {typeInc === 'Инцидент' && status.ID === incStatus.closed &&
                        <></>
                        ||
                        <div className='flex flex-row w-full items-center gap-[16px]'>
                            <div className="flex justify-end max-w-[140px] w-full">
                                <div style={{ backgroundColor: status.Color }} className="flex flex-row text-white py-[5px] px-[14px] rounded-md text-sm h-fit">{status.Title}</div>
                            </div>
                            <div className="text-black text-sm">{status.TextInc}</div>
                        </div>
                    }
                </>
            ))}
            <div className="flex flex-col mt-[10px]">
                {typeInc && typeInc === 'Инцидент' &&
                    <>
                        <p className="text-black text-sm">Y для Инцидента по Security = {Number(params.find((param: any) => param.Key === "IncSecurityDate")["Value"].trim())}</p>
                    </>
                }
            </div>
        </div>
    );
}